import { episodeConstants } from '../actions/constants/episodeConstants';

const episodeData = (state = { items: [], error: '', minDate: '', itemValue: {} }, action: any) => {
	switch (action.type) {
		case episodeConstants.EpisodeGetByFilterRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isListSuccess: false
			};
		case episodeConstants.EpisodeGetByFilterSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isListSuccess: true,
				isSuccess: true,
				status: action.payload.status,
				items: (action.payload !== "" && action.payload !== null) ? action.payload.episodes : [],
				totalCount: (action.payload !== "" && action.payload !== null) ? action.payload.totalCount : 1
			};
		case episodeConstants.EpisodeGetByFilterFailure:
			return {
				...state,
				isLoading: false,
				isError: true,
				isListSuccess: true,
				isSuccess: false,
				status: action.payload,
				items: []
			};
		case episodeConstants.EpisodeGetDropdownRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isDropdownListSuccess: false
			};
		case episodeConstants.EpisodeGetDropdownSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isDropdownListSuccess: true,
				status: action.status,
				episodeTypes: (action.episodeType !== "" && action.episodeType !== null) ? action.episodeType.episodeTypes : [],
				channels: (action.channel !== "" && action.channel !== null) ? action.channel.channels : [],
				bookMarkTypes: (action.bookMarkType !== "" && action.bookMarkType !== null) ? action.bookMarkType.bookMarkTypes : []
			};
		case episodeConstants.EpisodeGetDropdownFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isDropdownListSuccess: true,
				status: action.payload,
				bibles: [],
				episodeTypes: [],
				bookMarkTypes: [],
				channels: []
			};

		case episodeConstants.EpisodeGetDetailRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
			};
		case episodeConstants.EpisodeGetDetailSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isDetailComplete: true,
				isSuccess: true,
				episodesInput: action.payload.episode
			};
		case episodeConstants.EpisodeGetDetailFailure:
			return {
				...state,
				isLoading: false,
				isError: true,
				isDetailComplete: true,
				status: action.payload
			};

		case episodeConstants.EpisodeSaveRequest:
			return {
				...state,
				isLoading: true,
				isFormSubmit: true,
				isError: false,
				isSuccess: false,
				episodesInput: action.input,
			};
		case episodeConstants.EpisodeSaveSuccess:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isError: false,
				isSuccess: true,
				status: action.payload.status 
			};
		case episodeConstants.EpisodeSaveFailure:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isSuccess: false,
				isError: true,
				status: action.payload
			};

		case episodeConstants.EpisodeDeleteRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isDeleteCompleted: false
			};
		case episodeConstants.EpisodeDeleteSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isDeleteCompleted: true,
				status: action.payload.status
			};
		case episodeConstants.EpisodeDeleteFailure:
			return {
				...state,
				isLoading: false,
				isError: true,
				isSuccess: false,
				isDeleteCompleted: true,
				status: action.payload,
			};

		case episodeConstants.EpisodeGetReadingRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isReadingDataSuccess: false
			};
		case episodeConstants.EpisodeGetReadingSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isReadingDataSuccess: true,
				isSuccess: true,
				status: action.payload.status,
				readingData: action.payload.reading
			};
		case episodeConstants.EpisodeGetReadingFailure:
			return {
				...state,
				isLoading: false,
				readingData: null,
				isError: true,
				isReadingDataSuccess: true,
				status: action.payload
			};

		case episodeConstants.EpisodeGetReadingIdRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
			};
		case episodeConstants.EpisodeGetReadingIdSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isReadingIdSuccess: true,
				isSuccess: true,
				status: action.payload.status,
				readingIdData: action.payload.result
			};
		case episodeConstants.EpisodeGetReadingIdFailure:
			return {
				...state,
				isLoading: false,
				isError: true,
				isReadingIdSuccess: true,
				status: action.payload
			};

		case episodeConstants.EpisodeGetUserCountRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
			};
		case episodeConstants.EpisodeGetUserCountSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isListSuccess: true,
				isSuccess: true,
				status: action.payload.status,
				items: (action.payload !== "" && action.payload !== null) ? action.payload.userEpisodes : [],
			};
		case episodeConstants.EpisodeGetUserCountFailure:
			return {
				...state,
				isLoading: false,
				isError: true,
				isListSuccess: true,
				status: action.payload,
				items: []
			};
		case episodeConstants.EpisodeGetUserEngagementRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isEpisodeEngagementLoaded: false
			};
		case episodeConstants.EpisodeGetUserEngagementSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isEpisodeEngagementLoaded: true,
				status: action.payload.status,
				episodeEngagementData: action.payload
			};
		case episodeConstants.EpisodeGetUserEngagementFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				status: action.payload,
				isEpisodeEngagementLoaded: true,
			};
		case episodeConstants.EpisodeGetMinDateRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false
			};
		case episodeConstants.EpisodeGetMinDateSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				status: action.payload.status,
				minDate: action.payload.minDate,
				maxDate: action.payload.maxDate
			};
		case episodeConstants.EpisodeGetMinDateFailure:
			return {
				...state,
				isLoading: false,
				isError: true,
				isListSuccess: true,
				isSuccess: false,
				status: action.payload
			};
		case episodeConstants.EpisodeValidateFeedRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
			};
		case episodeConstants.EpioseValidateFeedSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				status: action.payload.status,
				itemValue: action.payload,
			};
		case episodeConstants.EpioseValidateFeedFailure:
			return {
				...state,
				isLoading: false,
				isError: true,
				isSuccess: false,
				status: action.payload
			};
		case episodeConstants.EpisodeUserMetricRequest:
			return {
				...state,
				isApiLoading: true,
				isApiSuccess: false,
				isError: false
			};
		case episodeConstants.EpisodeUserMetricSuccess:
			return {
				...state,
				isApiLoading: false,
				isApiSuccess: true,
				isError: false,
				items: action.payload.userEpisodeMetricDTO
			};
		case episodeConstants.EpisodeUserMetricFailure:
			return {
				...state,
				isApiLoading: false,
				isApiSuccess: false,
				isError: true,
				status: action.payload
			};
		case episodeConstants.EpisodeUpdateEngagementRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isEngagementUpdated: false
			};
		case episodeConstants.EpisodeUpdateEngagementSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isEngagementUpdated: true,
				lastEngagementUpdate: { meta: action.meta, success: true },
				engagementUpdateTick: ((state as any).engagementUpdateTick || 0) + 1,
				status: action.payload ? action.payload.status : null
			};
		case episodeConstants.EpisodeUpdateEngagementFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isEngagementUpdated: false,
				lastEngagementUpdate: { meta: action.meta, success: false, error: action.payload },
				engagementUpdateTick: ((state as any).engagementUpdateTick || 0) + 1,
				status: action.payload
			};
		default:
			return state;
	}
};

export default episodeData;
